import { getEditorPlugin,type PlateEditor } from '@udecode/plate/react';
import { isSelecting } from '@udecode/plate-selection';
import type { ChatRequestOptions } from 'ai';

import { AIPlugin } from '../../ai/AIPlugin';
import type { AIChatPluginConfig } from '../AIChatPlugin';
import { type EditorPrompt, getEditorPrompt } from './getEditorPrompt';

export const submitAIChat = (
    editor: PlateEditor,
    {
        mode,
        options,
        prompt,
        system,
    }: {
    mode?: 'chat' | 'insert';
    options?: ChatRequestOptions;
    prompt?: EditorPrompt;
    system?: EditorPrompt;
  } = {}
) => {
    const { getOptions, setOption } = getEditorPlugin<AIChatPluginConfig>(
        editor,
        {
            key: 'aiChat',
        }
    );

    const { chat, promptTemplate, systemTemplate } = getOptions();

    if (!prompt) {
        return;
    }
    if (!mode) {
        mode = isSelecting(editor) ? 'chat' : 'insert';
    }
    
    if (mode === 'insert') {
        editor.getTransforms(AIPlugin).ai.undo();
    }

    setOption('mode', mode);

    void chat.sendMessage?.({
        role: 'user',
        parts: [{
            type: 'text',
            text: getEditorPrompt(editor, {
                prompt,
                promptTemplate,
            }) ?? ''
        }]
    }, {
        body: {
            system: getEditorPrompt(editor, {
                prompt: system,
                promptTemplate: systemTemplate,
            }),
        },
        ...options,
    });
};
